export default __webpack_public_path__ + "img/visa.6332944e.png";